module.exports = __webpack_public_path__ + "static/media/Violette Immediate Suspension Order_Redacted.c5ed4390.pdf";